import React from 'react'
import {MetaData} from './MetaData';
import {Thumbnail} from './Thumbnail';
import {Content} from './Content';
import styled from 'styled-components';

const styles = {
    publicSector: {
        background: '#fff;'
    },
    health: {
        dimmedBg: true,
        background: '#fff;',
        // srcShadow: '0px 4px 16px rgba(236, 0, 146, 0.48);',
        overlay: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%);',
    },
    connectivity: {
        dimmedBg: true,
        background: '#fff;',
        overlay: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%);',
    },
    transactions: {
        dimmedBg: true,
        background: '#fff;',
        srcShadow: '0px 4px 16px rgba(142, 197, 252, 0.64);',
        overlay: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%);'

    }
};

const Wrapper = styled.div`
    background: ${({background, source}) => background || styles[source].background};
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 34px rgba(0, 0, 0, 0.16);

    min-height: 350px;
    height: 100%;
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    &::after {
        content:" ";
        position: absolute;
        top:0; left:0;
        bottom: 0; right: 0;
        background: #8EC5FC;
        background-image: ${({source}) => styles[source].overlay || 'none'};
        opacity: 0.5;
        border-radius: 16px;
        display: ${({source}) => styles[source].dimmedBg ? 'block' : 'none'};
    }
    * {
        color: ${({source}) => styles[source].textColor || '#fff'};
        z-index: 1;
    }
    a {
        text-decoration: none;

    }
`;
const Card = ({logo, source, url, background, tagline, textColor, thumbnail, title, author, meta, postType}) => {
    const content = {logo, title, postType, author, tagline, source};
    return(
        <a target="_blank" href={url}>
            <Wrapper background={background} source={source}>
                    {thumbnail && <Thumbnail shadow={styles[source].shadow} backgroundTop={styles[source].backgroundTop} src={thumbnail} />}
                    <Content content={content} srcShadow={styles[source].srcShadow} />
                    <MetaData meta={url} />
            </Wrapper>
        </a>
    )
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card/index.js